const agentsPageResources = {
  en: {
    agentsPage: {
      title: 'Insurance agents',
      jobOpportunity: 'Working for the best company',
      earnAsYouWant: 'Earn as much as you want',
      distanceLearning: 'Distance learning, anywhere, anytime',
      allWorkAutomated: 'All work is automated',
      flexibleSchedule: 'Free schedule',
      trainingToBecomeAgent:
        'Complete training to become an agent of our company',
      trainingPrograms: 'Training programs',
      howToBecomeAgent: 'How to become an insurance agent?',
      ogpoVts: 'OGPO VTS',
      casco: 'CASCO',
      afterTrainingProceedToTesting:
        'After studying the training programs, proceed to knowledge testing.',
      questionsToEmail: 'Please send questions to the email address:',
      signNameAndSpecifyContact:
        'Be sure to sign first and last name, specify your contact phone number.',
      takeTheTest: 'Take the test',
      yourData: 'Your data',
      fillInYourData: 'Fill in the data about yourself',
      iinBin: 'IIN / BIN',
      fullName: 'Full name',
      status: 'Status',
      phone: 'Phone number',
      email: 'Your e-mail',
      workExperience: 'Work experience',
      enterWork: 'Enter your work experience',
      regionOfResidence: 'Region of residence',
      testing: 'Testing',
      question: 'Question',
      next: 'Next',
      finish: 'Finish',
      thankYouForTest: 'Thank you for passing the test!',
      thnakYouForTest2:
        'Your result has been received. Our staff will contact you shortly for further steps.',
      allQuestions: 'You answered all the questions!',
      yourResult: 'Your result:',
      student: 'Student',
      graduate: 'Graduate',
      working: 'Working',
      unemployed: 'Unemployed',
      pensioner: 'Pensioner',
      validateIIN: 'Enter IIN',
      validateFullName: 'Enter your full name',
      validateStatus: 'Select status',
      validatePhone: 'Enter phone number',
      validateEmail: 'Enter your e-mail',
      validateExperience: 'Enter your work experience',
      validateRegion: 'Select region of residence',
    },
  },
  kz: {
    agentsPage: {
      title: 'Сақтандыру агенттері',
      jobOpportunity: 'Үздік компанияда жұмыс істеу',
      earnAsYouWant: 'Қалағаныңызша ақша табыңыз',
      distanceLearning:
        'Қашықтықтан оқыту, кез келген жерде, кез келген уақытта',
      allWorkAutomated: 'Барлық жұмыс автоматтандырылған',
      flexibleSchedule: 'Тегін кесте',
      trainingToBecomeAgent:
        'Біздің компанияның агенті болу үшін тренингті өтіңіз',
      trainingPrograms: 'Оқыту бағдарламалары',
      howToBecomeAgent: 'Қалай сақтандыру агенті болуға болады?',
      ogpoVts: 'Міндетті автосақтандыру',
      casco: 'КАСКО',
      afterTrainingProceedToTesting:
        'Оқу бағдарламаларын оқығаннан кейін тестілеуді өтіңіз.',
      questionsToEmail: 'Сұрақтарды электрондық мекенжайға жіберуді сұраймыз:',
      signNameAndSpecifyContact:
        'Аты - жөніңізге қол қоюды ұмытпаңыз, байланыс телефоныңызды көрсетіңіз.',
      takeTheTest: 'Тестілеуден өту',
      yourData: 'Сіздің деректеріңіз',
      fillInYourData: 'Өзіңіз туралы мәліметтерді толтырыңыз',
      iinBin: 'ЖСН / БСН',
      fullName: 'Толық аты-жөніңіз',
      status: 'Мәртебеңіз',
      phone: 'Телефон нөмірі',
      email: 'Сіздің e-mail',
      workExperience: 'Жұмыс тәжірибесі',
      enterWork: 'Жұмыс тәжірибеңізді енгізіңіз',
      regionOfResidence: 'Тұрғылықты жері',
      testing: 'Тестілеу',
      question: 'Сұрақ',
      next: 'Келесі',
      finish: 'Аяқтау',
      thankYouForTest: 'Тест тапсырғаныңыз үшін рахмет!',
      thankYouForTest2:
        'Сіздің нәтижеңіз алынды. Жақын арада біздің қызметкерлер келесі қадамдар үшін сізге хабарласыңыз.',
      allQuestions: 'Сіз барлық сұрақтарға жауап бердіңіз!',
      yourResult: 'Сіздің нәтижесіңіз:',
      student: 'Студент',
      graduate: 'Түлек',
      working: 'Жұмысшы',
      unemployed: 'Жұмыссыз',
      pensioner: 'Зейнеткер',
      validateIIN: 'ЖСН енгізіңіз',
      validateFullName: 'Аты-жөнінңізді енгізіңіз',
      validateStatus: 'Мәртебені таңдаңыз',
      validatePhone: 'Телефон нөміріңізді енгізіңіз',
      validateEmail: 'Электрондық поштаңызды енгізіңіз',
      validateExperience: 'Жұмыс тәжірибесін енгізіңіз',
      validateRegion: 'Аймақты таңдаңыз',
    },
  },
  ru: {
    agentsPage: {
      title: 'Страховые агенты',
      jobOpportunity: 'Работа в лучшей компании',
      earnAsYouWant: 'Зарабатывай сколько хочешь',
      distanceLearning: 'Дистанционное обучение, в любом месте, в любое время',
      allWorkAutomated: 'Вся работа автоматизирована',
      flexibleSchedule: 'Свободный график',
      trainingToBecomeAgent:
        'Пройдите обучение чтобы стать агентом нашей компании',
      trainingPrograms: 'Программы обучения',
      howToBecomeAgent: 'Как стать страховым агентом?',
      ogpoVts: 'ОГПО ВТС',
      casco: 'КАСКО',
      afterTrainingProceedToTesting:
        'После изучения Программ обучения, перейдите к тестированию знаний.',
      questionsToEmail: 'Просим направлять вопросы на электронный адрес:',
      signNameAndSpecifyContact:
        'Обязательно подпишите имя и фамилию, укажите свой контактный телефон.',
      takeTheTest: 'Пройти тестирование',
      yourData: 'Ваши данные',
      fillInYourData: 'Заполните данные о себе',
      iinBin: 'ИИН / БИН',
      fullName: 'ФИО',
      status: 'Статус',
      phone: 'Номер телефона',
      email: 'Ваш e-mail',
      workExperience: 'Опыт работы',
      enterWork: 'Введите ваш опыт работы',
      regionOfResidence: 'Регион проживания',
      testing: 'Тестирование',
      question: 'Вопрос',
      next: 'Далее',
      finish: 'Завершить',
      thankYouForTest: 'Спасибо за прохождение теста!',
      thankYouForTest2:
        'Ваш результат получен. Наши сотрудники свяжутся с Вами в ближайшее время для дальнейших шагов.',
      allQuestions: 'Вы ответили на все вопросы!',
      yourResult: 'Ваш результат:',
      student: 'Студент',
      graduate: 'Выпускник',
      working: 'Работающий',
      unemployed: 'Безработный',
      pensioner: 'Пенсионер',
      validateIIN: 'Введите ИИН',
      validateFullName: 'Введите ФИО',
      validateStatus: 'Выберите статус',
      validatePhone: 'Введите номер телефона',
      validateEmail: 'Введите ваш e-mail',
      validateExperience: 'Введите ваш опыт работы',
      validateRegion: 'Выберите регион проживания',
    },
  },
};

export default agentsPageResources;
